import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Shipments = () => {
  return import('@/components/Shipments')
}

const ShipmentDetail = () => {
  return import('@/components/ShipmentDetail')
}

const Setting = () => {
  return import('@/components/Setting')
}

const Login = () => {
  return import('@/components/Login')
}

const GoodsStatus = () => {
  return import('@/components/GoodsStatus')
}

const GoodsStatusUpdate = () => {
  return import('@/components/GoodsStatusUpdate')
}

const PiecesStatus = () => {
  return import('@/components/PiecesStatus')
}

const PiecesStatusUpdate = () => {
  return import('@/components/PiecesStatusUpdate')
}

const PrintLabel = () => {
  return import('@/components/PrintLabel')
}

const PrintHawbLabel = () => {
  return import('@/components/PrintHawbLabel')
}

const Scan = () => {
  return import('@/components/Scan')
}

const GoodsDmgImgUpload = () => {
  return import('@/components/GoodsDmgImgUpload')
}

const GeneralScan = () => {
  return import('@/components/GeneralScan')
}

const NsappShipments = () => {
  return import('@/nsapp_components/NsappShipments')
}

const NsappShipmentsGuide = () => {
  return import('@/nsapp_components/NsappShipmentGuide')
}

const NsappShipmentDetail = () => {
  return import('@/nsapp_components/NsappShipmentDetail')
}

const WarehouseCheckDetail = () => {
  return import('@/nsapp_components/WarehouseCheckDetail')
}

const NsappShipmentDetail2 = () => {
  return import('@/nsapp_components/NsappShipmentDetail')
}

const NsappShipmentDetail3 = () => {
  return import('@/nsapp_components/NsappShipmentDetail')
}

const NsappShipmentsStatus = () => {
  return import('@/nsapp_components/NsappShipmentsStatus')
}

const NsappShipmentsStatusUpdate = () => {
  return import('@/nsapp_components/NsappShipmentsStatusUpdate')
}

const NokiaKnCheck = () => {
  return import('@/components/NokiaKnCheck')
}

const NokiaScan = () => {
  return import('@/components/NokiaScan')
}

const NsappShipmentsOutboundHawb = () => {
  return import('@/nsapp_components/NsappShipmentsOutboundHawb')
}

const NsappShipmentsOutboundMawb = () => {
  return import('@/nsapp_components/NsappShipmentsOutboundMawb')
}

const NsappShipmentsWarehouseCheck = () => {
  return import('@/nsapp_components/NsappShipmentsWarehouseCheck')
}

const NsappShipmentsAssignmentManagement = () => {
  return import('@/nsapp_components/NsappShipmentsAssignmentManagement')
}

const AssignmentDetail = () => {
  return import('@/nsapp_components/AssignmentDetail')
}

const NsappDockTasks = () => {
  return import('@/nsapp_components/NsappDockTasks')
}

const NsappDockTaskDetail = () => {
  return import('@/nsapp_components/NsappDockTaskDetail')
}

const NsappOutboundShipmentHawbDetail = () => {
  return import('@/nsapp_components/NsappOutboundShipmentHawbDetail')
}

const NsappOutboundShipmentMawbDetail = () => {
  return import('@/nsapp_components/NsappOutboundShipmentMawbDetail')
}

const NsappOutboundShipmentsStatus = () => {
  return import('@/nsapp_components/NsappOutboundShipmentsStatus')
}

const NsappOutboundShipmentsStatusUpdate = () => {
  return import('@/nsapp_components/NsappOutboundShipmentsStatusUpdate')
}

export default new Router({
  routes: [
    {
      path: `/`,
      menuname: `/login`,
      name: 'Login',
      component: Login
    },
    {
      path: `/eh/mobile/eh/login/page`,
      menuname: `/login2`,
      name: 'Login2',
      component: Login
    },
    {
      path: `/eh/mobile/shipments`,
      menuname: `/eh/mobile/shipments`,
      name: 'Shipments',
      component: Shipments
    },
    {
      path: `/eh/mobile/shipments/completed`,
      menuname: `/eh/mobile/shipments/completed`,
      name: 'ShipmentsCompleted',
      component: Shipments
    },
    {
      path: `/eh/mobile/setting`,
      menuname: `/eh/mobile/setting`,
      name: 'Setting',
      component: Setting
    },
    {
      path: `/eh/mobile/shipments/detail/:s_id`,
      menuname: `/eh/mobile/shipments/detail`,
      name: 'ShipmentDetail',
      component: ShipmentDetail
    },
    {
      path: `/eh/mobile/order/goods/status/:g_id`,
      menuname: `/eh/mobile/order/goods/status`,
      name: 'GoodsStatus',
      component: GoodsStatus
    },
    {
      path: `/eh/mobile/order/goods/status/update/:order_id/:g_id/:g_s_id/:status_mark`,
      menuname: `/eh/mobile/order/goods/status/update`,
      name: 'GoodsStatusUpdate',
      component: GoodsStatusUpdate
    },
    {
      path: `/eh/mobile/order/goods/pieces/status/:p_id`,
      menuname: `/eh/mobile/order/goods/pieces/status`,
      name: 'PiecesStatus',
      component: PiecesStatus
    },
    {
      path: `/eh/mobile/order/goods/pieces/status/update/:order_id/:g_id/:p_id/:p_s_id/:status_mark`,
      menuname: `/eh/mobile/order/goods/pieces/status/update`,
      name: 'PiecesStatusUpdate',
      component: PiecesStatusUpdate
    },
    {
      path: `/eh/mobile/order/goods/print/lable/:g_id`,
      menuname: `/eh/mobile/order/goods/print/lable`,
      name: 'PrintLabel',
      component: PrintLabel
    },
    {
      path: `/eh/mobile/order/goods/print_hawb/lable/:g_id`,
      menuname: `/eh/mobile/order/goods/print_hawb/lable`,
      name: 'PrintHawbLabel',
      component: PrintHawbLabel
    },
    {
      path: `/eh/mobile/scan`,
      menuname: `/eh/mobile/scan`,
      name: 'Scan',
      component: Scan
    },
    {
      path: `/eh/mobile/goods/upload/dmimg/page/:g_id`,
      menuname: `/eh/mobile/goods/upload/dmimg/page`,
      name: 'GoodsDmgImgUpload',
      component: GoodsDmgImgUpload
    },
    {
      path: `/eh/mobile/general/scan`,
      menuname: `/eh/mobile/general/scan`,
      name: 'GeneralScan',
      component: GeneralScan
    },
    {
      path: `/nsapp/mobile/shipments/guide`,
      menuname: `/nsapp/mobile/shipments/guide`,
      name: 'NsappShipmentsGuide',
      component: NsappShipmentsGuide
    },
    {
      path: `/nsapp/mobile/dock/tasks`,
      menuname: `/nsapp/mobile/dock/tasks`,
      name: 'NsappDockTasks',
      component: NsappDockTasks
    },
    {
      path: `/nsapp/mobile/dock/tasks/:id`,
      menuname: `/nsapp/mobile/dock/tasks/detail`,
      name: 'NsappDockTaskDetail',
      component: NsappDockTaskDetail
    },
    {
      path: `/nsapp/mobile/shipments`,
      menuname: `/nsapp/mobile/shipments`,
      name: 'NsappShipments',
      component: NsappShipments
    },
    {
      path: `/nsapp/mobile/outbound/shipments/hawb`,
      menuname: `/nsapp/mobile/outbound/shipments/hawb`,
      name: 'NsappShipmentsOutboundHawb',
      component: NsappShipmentsOutboundHawb
    },
    {
      path: `/nsapp/mobile/outbound/shipments/mawb`,
      menuname: `/nsapp/mobile/outbound/shipments/mawb`,
      name: 'NsappShipmentsOutboundMawb',
      component: NsappShipmentsOutboundMawb
    },
    {
      path: `/nsapp/mobile/warehouse/check/:w_type?`,
      menuname: `/nsapp/mobile/warehouse/check`,
      name: 'NsappShipmentsWarehouseCheck',
      component: NsappShipmentsWarehouseCheck
    },
    {
      path: `/nsapp/mobile/assignment/management/:tab?`,
      menuname: `/nsapp/mobile/assignment/management`,
      name: 'NsappShipmentsAssignmentManagement',
      component: NsappShipmentsAssignmentManagement
    },
    {
      path: `/nsapp/mobile/outbound/shipments/hawb/detail/:s_id`,
      menuname: `/nsapp/mobile/outbound/shipments/hawb/detail`,
      name: 'NsappOutboundShipmentHawbDetail',
      component: NsappOutboundShipmentHawbDetail
    },
    {
      path: `/nsapp/mobile/assignment/detail/:tab/:id`,
      menuname: `/nsapp/mobile/assignment/detail`,
      name: 'AssignmentDetail',
      component: AssignmentDetail
    },
    {
      path: `/nsapp/mobile/outbound/shipments/mawb/detail/:s_id`,
      menuname: `/nsapp/mobile/outbound/shipments/mawb/detail`,
      name: 'NsappOutboundShipmentMawbDetail',
      component: NsappOutboundShipmentMawbDetail
    },
    {
      path: `/nsapp/mobile/shipments/detail/:s_id`,
      menuname: `/nsapp/mobile/shipments/detail`,
      name: 'NsappShipmentDetail',
      component: NsappShipmentDetail
    },
    {
      path: `/nsapp/mobile/warehouse/check/detail/:c_id/:w_type`,
      menuname: `/nsapp/mobile/warehouse/check/detail`,
      name: 'WarehouseCheckDetail',
      component: WarehouseCheckDetail
    },
    {
      path: `/nsapp/mobile/shipments/detail/p2/:s_id`,
      menuname: `/nsapp/mobile/shipments/detail/p2`,
      name: 'NsappShipmentDetail2',
      component: NsappShipmentDetail2
    },
    {
      path: `/nsapp/mobile/shipments/detail/p3/:s_id`,
      menuname: `/nsapp/mobile/shipments/detail/p3`,
      name: 'NsappShipmentDetail3',
      component: NsappShipmentDetail3
    },
    {
      path: `/nsapp/mobile/order/shipments/status/:g_id`,
      menuname: `/nsapp/mobile/order/shipments/status`,
      name: 'NsappShipmentsStatus',
      component: NsappShipmentsStatus
    },
    {
      path: `/nsapp/mobile/outbound/shipments/status/:g_id`,
      menuname: `/nsapp/mobile/outbound/shipments/status`,
      name: 'NsappOutboundShipmentsStatus',
      component: NsappOutboundShipmentsStatus
    },
    {
      path: `/nsapp/mobile/order/shipments/status/update/:shipment_id/:status_mark`,
      menuname: `/nsapp/mobile/order/shipments/status/update`,
      name: 'NsappShipmentsStatusUpdate',
      component: NsappShipmentsStatusUpdate
    },
    {
      path: `/nsapp/mobile/outbound/shipments/status/update/:shipment_id/:status_mark`,
      menuname: `/nsapp/mobile/outbound/shipments/status/update`,
      name: 'NsappOutboundShipmentsStatusUpdate',
      component: NsappOutboundShipmentsStatusUpdate
    },
    {
      path: `/eh/mobile/nokia/kn/scan`,
      menuname: `/eh/mobile/nokia/kn/scan`,
      name: 'NokiaKnCheck',
      component: NokiaKnCheck
    },
    {
      path: `/eh/mobile/nokia/kn/scan/by/goods/hawb/:type`,
      menuname: `/eh/mobile/nokia/kn/scan/by/goods/hawb`,
      name: 'NokiaScan',
      component: NokiaScan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js